import Studio from '../../features/studio/layouts/studio';

export default function StudioPage() {
    return <Studio />;
}
